import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { useSelection } from '../../hooks/useSelection';

function PreviewTab() {
  const { files } = useAppContext();
  const { primaryIndex } = useSelection();
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (primaryIndex >= 0 && files[primaryIndex]) {
      const file = files[primaryIndex].file;
      const url = URL.createObjectURL(file);
      setImageUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      setImageUrl(null);
    }
  }, [primaryIndex, files]);

  if (!imageUrl) {
    return (
      <div className="flex flex-col items-center justify-center p-8 py-12 bg-bg-tertiary/20 rounded-md border border-dashed border-border-default/60 text-text-supporting text-center animate-pulse">
        <p className="text-[12px] font-sans">Select a file to preview</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <img
        src={imageUrl}
        alt="Preview"
        className="w-full rounded-md border border-border-default/70 shadow-md object-contain max-h-[400px] hover:border-accent-amber/30 transition-all cursor-zoom-in"
      />
    </div>
  );
}

export default PreviewTab;
